import React from "react";
import {
  letterDict,
  chunkArray as autoCompleteChunkArray,
  boundariedChunkedArray,
} from "Components/AutoCompleteList";

import { state } from "State";
import { communityValues, geoAggregations, minorGroups } from "Data";
import { Tooltip } from "reactstrap";
import withState from "recompose/withState";

const selectFromState = ({ domain_data, ui }) => ({
  collection: (
    communityValues[domain_data.year][domain_data.community] || []
  ).filter(
    (name) =>
      name.toLowerCase().indexOf(ui.community_search_input.toLowerCase()) !== -1
  ),
});

const addToolTipState = withState("tooltipOpen", "setTooltipOpen", false);

const MinorGroupsHeadingWithTooltip = addToolTipState(({ tooltipOpen, setTooltipOpen }) => (
  <React.Fragment>
    <div
      style={{ paddingLeft: "15px", display: 'flex', alignItems: 'center', marginTop: 8, marginBottom: 12, fontWeight: 'bold', fontSize: '1.1em' }}
    >
      Minor Groups
      <span
        id="MinorGroupsInfoIcon"
        style={{ marginLeft: 8, cursor: 'pointer', display: 'inline-flex', alignItems: 'center' }}
        tabIndex={0}
      >
        <i className="fa fa-info-circle" aria-hidden="true" />
      </span>
      <Tooltip
        placement="right"
        isOpen={tooltipOpen}
        target="MinorGroupsInfoIcon"
        toggle={() => setTooltipOpen(!tooltipOpen)}
      >
        Groupings of countries according to the Standard Australian Classification of Countries. For more information, visit the Glossary.
      </Tooltip>
    </div>
  </React.Fragment>
));

// Birthplace-specific menu (with Minor Groups)
const BirthplaceSearchMenu = ({ hidden, tree, collection, filteredMinorGroups, showMinorGroups }) => {
  // Helper to chunk Minor Groups into 4 columns
  function chunkArray(array, chunkCount) {
    const chunkSize = Math.ceil(array.length / chunkCount);
    return Array.from({ length: chunkCount }, (_, i) =>
      array.slice(i * chunkSize, i * chunkSize + chunkSize)
    );
  }
  const minorGroupColumns = chunkArray(filteredMinorGroups, 4);
  return (
    <div style={{ overflowY: "scroll", height: "90vh" }} hidden={hidden} id="primary-search-menu" className="fade white">
      {/* Minor Groups block */}
      {showMinorGroups && (
        <div style={{ marginBottom: 24, width: "100%"}}>
          <MinorGroupsHeadingWithTooltip />
          <div className="row" style={{ marginLeft: 0, marginRight: 0 }}>
            {minorGroupColumns.map((col, colIdx) => (
              <div key={colIdx} className="col-md-3 col-sm-4" style={{ minWidth: 60, paddingBottom: "20px" }}>
                {col.map(item => (
                  <div key={item} style={{ marginBottom: 4 }}>
                    <a className="simple-link" href="#" onMouseDown={() => {
                      state.select("ui").merge({ community_search_input: item });
                      state.select("domain_data").merge({ community_value: item });
                    }}>{item}</a>
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      )}
      {/* Divider and Countries heading - ensure full width */}
      {showMinorGroups && <hr style={{ margin: "0 0 24px 0", borderTop: "1px solid #bbb", width: "100%" }} />}
      <div style={{ paddingLeft: "15px", marginBottom: 8, fontWeight: "bold", fontSize: "1.1em", width: "100%" }}>Countries</div>
      <div className="row" style={{ marginLeft: 0, marginRight: 0 }}>
        {letterDict(
          collection,
          value =>
            state.select("ui").merge({ community_search_input: value }) &&
            state.select("domain_data").merge({ community_value: value })
        )
          .chain(col => boundariedChunkedArray(5)(col))
          .map((col, index) => (
            <div key={index} className="col-md-3 col-sm-4" style={{paddingBottom: "20px"}}>
              {col}
            </div>
          ))}
      </div>
    </div>
  );
};

// Default menu (single collection)
const DefaultSearchMenu = ({ hidden, collection }) => (
  <div
    style={{ overflowY: "scroll", height: "90vh" }}
    hidden={hidden}
    id="primary-search-menu"
    className="fade white"
  >
    {letterDict(
      collection,
      value =>
        state.select("ui").merge({ community_search_input: value }) &&
        state.select("domain_data").merge({ community_value: value })
    )
      .chain(col => boundariedChunkedArray(5)(col))
      .map((col, index) => (
        <div key={index} className="col-md-3 col-sm-4" style={{paddingBottom: "20px"}}>
          {col}
        </div>
      ))}
  </div>
);

// Router component
const PrimarySearchMenu = ({ hidden, tree }) => {
  const { collection: _collection } = selectFromState(tree);
  if (tree.domain_data.community.toLowerCase() === "birthplace") {
    // Filter out minor groups from main collection, and get filtered minor groups
    const collection = _collection.filter(c => !minorGroups.items.includes(c));
    const filteredMinorGroups = minorGroups.items.filter(m => _collection.includes(m));
    const showMinorGroups = filteredMinorGroups.length > 0;
    return (
      <BirthplaceSearchMenu
        hidden={hidden}
        tree={tree}
        collection={collection}
        filteredMinorGroups={filteredMinorGroups}
        showMinorGroups={showMinorGroups}
      />
    );
  }
  // Default
  return <DefaultSearchMenu hidden={hidden} collection={_collection} />;
};

export default PrimarySearchMenu;



// WEBPACK FOOTER //
// ./components/PrimarySearchMenu.js